import React, { useState } from "react";
import { menuCategories } from "../data/mock";
import { useReveal } from "../hooks/useReveal";
import { UtensilsCrossed } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { menuCategoryI18n, menuSubtitleI18n } from "../i18n/translations";

export default function Menu() {
  const { t, lang } = useLanguage();
  const [active, setActive] = useState(menuCategories[0].id);
  const r1 = useReveal();
  const cur = menuCategories.find((c) => c.id === active);

  const trCat = (name) =>
    lang === "de" ? name : (menuCategoryI18n[name]?.[lang] || name);
  const trSub = (sub) =>
    lang === "de" ? sub : (menuSubtitleI18n[sub]?.[lang] || sub);

  return (
    <section id="menu" className="py-24 bg-ivory relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{
        backgroundImage: "radial-gradient(#7A1F1F 1px, transparent 1px)",
        backgroundSize: "24px 24px"
      }} />

      <div className="max-w-6xl mx-auto px-6 relative">
        <div ref={r1.ref} className={`reveal ${r1.visible ? "in" : ""} text-center`}>
          <p className="section-sub">{t.menu.sub}</p>
          <h2 className="section-title text-4xl md:text-5xl mt-3">{t.menu.title}</h2>
          <div className="ornament mt-4">
            <UtensilsCrossed className="text-[#D4A94A]" size={20} />
          </div>
          <p className="mt-4 text-[#1B1512]/70 max-w-2xl mx-auto">
            {t.menu.desc}
          </p>
        </div>

        <div className="mt-10 flex gap-3 overflow-x-auto no-scrollbar pb-3 justify-start md:justify-center">
          {menuCategories.map((c) => (
            <button key={c.id} onClick={() => setActive(c.id)} className={`menu-tab ${active === c.id ? "active" : ""}`}>
              {trCat(c.name)}
            </button>
          ))}
        </div>

        <div key={active} className="mt-10 grid md:grid-cols-2 gap-x-14 zoom-in">
          <div className="md:col-span-2 text-center mb-4">
            <p className="font-display text-[#7A1F1F] text-2xl">{trCat(cur.name)}</p>
            <p className="text-sm tracking-[0.25em] uppercase text-[#E86D1F] mt-1">{trSub(cur.subtitle)}</p>
          </div>
          {cur.items.map((it, i) => (
            <div key={i} className="menu-item">
              <div>
                <div className="flex items-baseline gap-3">
                  <h4 className="font-display text-lg text-[#1B1512] font-semibold">{it.name}</h4>
                  <div className="dot-lead" />
                </div>
                <p className="text-sm text-[#1B1512]/70 mt-1 leading-relaxed">
                  {lang === "de" ? it.desc : (it[`desc_${lang}`] || it.desc)}
                </p>
              </div>
              <div className="font-display text-[#7A1F1F] text-xl font-bold whitespace-nowrap">{it.price} €</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
